export const urls = {
  GET_SERVISNE_ZAHTEVE: 'DokServisniZahtevi/vrati_dok_servisne_zahteve',
  GET_SERVISNE_ZAHTEVE_FILTER:
    'DokServisniZahtevi/servisni_zahtevi_vrati_sa_filterom',
  GET_SERVISNE_ZAHTEVE_FILTER_ZAVRSENI:
    'DokServisniZahtevi/servisni_zahtevi_vrati_sa_filterom_zavrseni',
  GET_STATUSI_COMBO: 'Combo/vrati_statuse_servisnog_zahteva',
};
